import React from 'react';
import { Container, PageHeading, Section } from '../../shared';
import './help.section.scss';
export var HelpSection = function (_a) {
    var content = _a.content, systemVText = _a.systemVText, version = _a.version;
    return (React.createElement("section", null,
        React.createElement(PageHeading, { headingLevel: 2, title: "Help", icon: "question" }),
        React.createElement(Container, null,
            React.createElement("div", { className: "help-section" },
                React.createElement("div", { id: "helpData" }),
                React.createElement(Section, { title: "Need help?", headerChildren: React.createElement("div", null) },
                    React.createElement("div", { dangerouslySetInnerHTML: { __html: content } }))))));
};
